import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card-toolbar text-center pt-5\" data-kt-buttons=\"true\"><a class=\"btn btn-sm btn-color-muted btn-active btn-active-primary active px-4 me-1\" id=\"kt_charts_widget_2_year_btn\">Year</a><a class=\"btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1\" id=\"kt_charts_widget_2_month_btn\">Month</a><a class=\"btn btn-sm btn-color-muted btn-active btn-active-primary px-4\" id=\"kt_charts_widget_2_week_btn\">Week</a></div><div class=\"card-header border-0 pt-5\"><h3 class=\"card-title align-items-start flex-column\"><span class=\"card-label fw-bolder fs-3 mb-1\">Total Bins <i class=\"bi bi-trash-fill fa-sm text-dark\" style=\"font-size:1.5rem;\"></i></span><div class=\"d-flex flex-row mt-2\"><div class=\"p-2 border-gray-300 border-end-dashed\"><span class=\"fw-bolder fs-1 text-primary\">330</span></div><div class=\"p-3\"><span class=\"fw-bolder fs-7 mt-1 text-gray-600\">Last Month: 290</span></div></div></h3></div>", 2)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center me-2" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "symbol-label bg-light" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash-fill fa-2x text-primary" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "fs-6 text-gray-800 text-hover-primary fw-bolder"
        }, "Total Bins")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "badge badge-light fw-bold py-4 px-3" }, "880")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "progress-bar bg-primary progress-bar progress-bar-striped progress-bar-animated",
      role: "progressbar",
      style: {"width":"100%"},
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center me-2" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "symbol-label bg-light" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash-fill fa-2x text-success" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "fs-6 text-gray-800 text-hover-primary fw-bolder"
        }, "Active Bins")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "badge badge-light fw-bold py-4 px-3" }, "700")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "progress-bar bg-success progress-bar progress-bar-striped progress-bar-animated",
      role: "progressbar",
      style: {"width":"75%"},
      "aria-valuenow": "75",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center me-2" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "symbol-label bg-light" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fa-2x" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "fs-6 text-gray-800 text-hover-primary fw-bolder"
        }, "Offline Bins")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "badge badge-light fw-bold py-4 px-3" }, "180")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "progress-bar bg-secondary progress-bar progress-bar-striped progress-bar-animated",
      role: "progressbar",
      style: {"width":"25%"},
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_apexchart, {
        class: "mixed-widget-7-chart",
        options: _ctx.chartOptions,
        series: _ctx.series,
        width: "100%",
        type: "donut"
      }, null, 8, ["options", "series"]),
      _hoisted_4
    ])
  ], 2))
}